import { MasterPageNames } from './masternames';

// View = Only Readable access not edit or Create Set Requests
// HasAllow / Create = Allows Readable as well as Edit,Create to Set Requests 

export const DataUploadApprovePagefieldMapping = {
    AllowDataUploadApprovePageView: 'DataUploadApprovePageView',
    HasAllowDataUploadApprovePage: 'HasDataUploadApprovePage',
    AllowDateView: 'DateView',
    HasAllowDate: 'HasDate',
    AllowFranchiseView: 'FranchiseView',
    HasAllowFranchise: 'HasFranchise',
    AllowRegionView: 'RegionView',
    HasAllowRegion: 'HasRegion',
    AllowEnableReuploadButtonView: 'EnableReuploadButtonView',
};

export const ReloadZylemDataPagefieldMapping = {
    AllowReloadZylemDataPageView: 'ReloadZylemDataPageView',
    HasAllowReloadZylemDataPage: 'HasReloadZylemDataPage',
    AllowReloadButtonView: 'ReloadButtonView',
    HasAllowReloadButton: 'HasReloadButton',
    AllowResyncButtonView: 'ResyncButtonView',
    HasAllowResyncButton: 'HasResyncButton'
};

export const DataMappingPagefieldMapping = {
    AllowDataMappingPageView: 'DataMappingPageView',
    HasAllowDataMappingPage: 'HasDataMappingPage',
    AllowImportMappingButtonView: 'ImportMappingButtonView',
    HasAllowImportMappingButton: 'HasImportMappingButton',
    AllowDownloadUnmappedButtonView: 'DownloadUnmappedButtonView',
    HasAllowDownloadUnmappedButton: 'HasDownloadUnmappedButton',
    AllowDataMappingStatusTabView: 'DataMappingStatusTabView',
    HasAllowDataMappingStatusTab: 'HasDataMappingStatusTab',
    AllowImportHistoryTabView: 'ImportHistoryTabView',
    HasAllowImportHistoryTab: 'HasImportHistoryTab',
    HasAllowProductMappingButton: 'HasProductMappingButton',
    HasAllowAccountMappingButton: 'HasAccountMappingButton',
    HasAllowSurgeonMappingButton: 'HasSurgeonMappingButton',
    HasAllowAddNewMappingButton: 'HasAddNewMappingButton',
};

export const EnableReuploadPagefieldMapping = {
    AllowEnableReuploadPageView: 'EnableReuploadPageView',
    HasAllowEnableReuploadPage: 'HasEnableReuploadPage',
    AllowEnableReuploadButtonView: 'EnableReuploadButtonView',
    HasAllowEnableReuploadButton: 'HasEnableReuploadButton'
};

export const DistributorConfigurationPagefieldMapping = {
    AllowDistributorConfigurationPageView: 'DistributorConfigurationPageView',
    HasAllowDistributorConfigurationPage: 'HasDistributorConfigurationPage',
    AllowDistributorSettingsView: 'DistributorSettingsView',
    HasAllowDistributorSettings: 'HasDistributorSettings',
    AllowDistConfigurationByRegionTabView: 'DistConfigurationByRegionTabView',
    HasAllowDistConfigurationByRegionTab: 'HasDistConfigurationByRegionTab',
    AllowDistConfigurationByFranchiseAndPeriodTabView: 'DistConfigurationByFranchiseAndPeriodTabView',
    AllowDataModeView: 'DataModeView',
    HasAllowDataMode: 'HasDataMode',
    AllowDistConfigurationCurrentDataTabView: 'DistConfigurationCurrentDataTabView',
    HasAllowDistConfigurationCurrentDataTab: 'HasDistConfigurationCurrentDataTab',
    AllowDistConfigurationHistoryTabView: 'DistConfigurationHistoryTabView',
    hasAllowDistConfigurationHistoryTab: 'hasDistConfigurationHistoryTab',
};


export const SystemConfigurationPagefieldMapping = {
    AllowSystemConfigurationPageView: 'SystemConfigurationPageView',
    HasAllowSystemConfigurationPage: 'HasSystemConfigurationPage'
};

export const ReportPagefieldMapping = {
    AllowDealerDataStatusPageView: 'DealerDataStatusPageView',
    HasAllowDealerDataStatusPage: 'HasDealerDataStatusPage',
    AllowDealerReportedSalesPageView: 'DealerReportedSalesPageView',
    HasAllowDealerReportedSalesPage: 'HasDealerReportedSalesPage',
    AllowDealerReportedSNSDataPageView: 'DealerReportedSNSDataPageView',
    HasAllowDealerReportedSNSDataPage: 'HasDealerReportedSNSDataPage',
    AllowDealerPriceReportPageView: 'DealerPriceReportPageView',
    HasAllowDealerPriceReportPage: 'HasDealerPriceReportPage',
    AllowDumpReportPageView: 'DumpReportPageView',
    HasAllowDumpReportPage: 'HasDumpReportPage',
    AllowDealerPurchaseReportPageView: 'DealerPurchaseReportPageView',
    HasAllowDealerPurchaseReportPage: 'HasDealerPurchaseReportPage',
    AllowActivityLogPageView: 'ActivityLogPageView',
    HasAllowActivityLogPage: 'HasActivityLogPage',
    AllowInventoryReportPageView: 'InventoryReportPageView',
    HasAllowInventoryReportPage: 'HasInventoryReportPage',
    AllowMySalesReportPageView: 'MySalesReportPageView',
    HasAllowMySalesReportPage: 'HasMySalesReportPage',
    AllowDealerSNSReportPageView: 'DealerSNSReportPageView',
    HasAllowDealerSNSReportPage: 'HasDealerSNSReportPage',
    AllowRequestReportPageView: 'RequestReportPageView',
    HasAllowRequestReportPage: 'HasRequestReportPage',
    AllowReportDateView: 'ReportDateView',
    HasAllowReportDate: 'HasReportDate',
    AllowReportFranchiseView: 'ReportFranchiseView',
    HasAllowReportFranchise: 'HasReportFranchise',
    HasAllowNewRequestButton: 'HasNewRequestButton',
    AllowModuleRoleAccessListPageView: 'ModuleRoleAccessListPageView',
    HasAllowModuleRoleAccessListPage: 'HasModuleRoleAccessListPage',
    AllowStandardPriceReportPageView: 'StandardPriceReportPageView',
    HasAllowStandardPriceReportPage: 'HasStandardPriceReportPage',
};


export const MastersPagefieldMapping = {};

MasterPageNames?.Masters.forEach(entity => {
    // const entityKey = entity === 'Page' ? '' : `_${entity}`;

    MastersPagefieldMapping[`AllowMastersPageView_${entity}`.toLowerCase()] = `MastersPageView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowMastersPageCreate_${entity}`.toLowerCase()] = `MastersPageCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowMastersPageImportButtonView_${entity}`.toLowerCase()] = `MastersPageImportButtonView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowMastersPageImportButtonCreate_${entity}`.toLowerCase()] = `MastersPageImportButtonCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowMastersPageNewUserButtonView_${entity}`.toLowerCase()] = `MastersPageNewUserButtonView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowMastersPageNewUserButtonCreate_${entity}`.toLowerCase()] = `MastersPageNewUserButtonCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowCurrentDataTabView_${entity}`.toLowerCase()] = `CurrentDataTabView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowCurrentDataTabCreate_${entity}`.toLowerCase()] = `CurrentDataTabCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowImportHistoryTabView_${entity}`.toLowerCase()] = `ImportHistoryTabView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowImportHistoryTabCreate_${entity}`.toLowerCase()] = `ImportHistoryTabCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowCurrentDataTabViewHistoryView_${entity}`.toLowerCase()] = `CurrentDataTabViewHistoryView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowCurrentDataTabViewHistoryCreate_${entity}`.toLowerCase()] = `CurrentDataTabViewHistoryCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowCurrentDataTabDeleteDataView_${entity}`.toLowerCase()] = `CurrentDataTabDeleteDataView_${entity}`.toLowerCase();
    MastersPagefieldMapping[`AllowCurrentDataTabDeleteDataCreate_${entity}`.toLowerCase()] = `CurrentDataTabDeleteDataCreate_${entity}`.toLowerCase();

    MastersPagefieldMapping[`AllowEditUserView`.toLowerCase()] = `EditUserView`.toLowerCase();
    MastersPagefieldMapping[`AllowActivateUserView`.toLowerCase()] = `ActivateUserView`.toLowerCase();
    MastersPagefieldMapping[`AllowUserMasterMoreMenuView`.toLowerCase()] = `UserMasterMoreMenuView`.toLowerCase();
});

export default MastersPagefieldMapping;


export const DashboardPagefieldMapping = {
    AllowDashboardPageView: 'DashboardPageView',
    HasAllowDashboardPage: 'HasDashboardPage',
    AllowMyDealersDashboardPageView: 'MyDealersDashboardPageView',
    HasAllowMyDealersDashboardPage: 'HasMyDealersDashboardPage',
    AllowRegionView: 'RegionView',
    HasAllowRegion: 'HasRegion',
    AllowLastMonthRecordsView: 'LastMonthRecordsView',
    HasAllowLastMonthRecords: 'HasLastMonthRecords',
    HasAllowTop10Products: 'HasTop10Products',
    HasAllowTop10Customers: 'HasTop10Customers',
    AllowDashboardFiltersView: 'DashboardFiltersView',
    HasAllowDashboardFilters: 'HasDashboardFilters',
};

export const DataUploadPagefieldMapping = {
    AllowDataUploadPageView: 'DataUploadPageView',
    HasAllowDataUploadPage: 'HasDataUploadPage',
    AllowDataUploadStatusTabView: 'DataUploadStatusTabView',
    HasAllowDataUploadStatusTab: 'HasDataUploadStatusTab',
    AllowTemplateInformationTabView: 'TemplateInformationTabView',
    HasAllowTemplateInformationTab: 'HasTemplateInformationTab',
};

export const SNSUploadPagefieldMapping = {
    AllowSNSUploadPageView: 'SNSUploadPageView',
    HasAllowSNSUploadPage: 'HasSNSUploadPage',
    AllowSNSUploadStatusTabView: 'SNSUploadStatusTabView',
    HasAllowSNSUploadStatusTab: 'HasSNSUploadStatusTab',
    AllowTemplateInformationTabView: 'TemplateInformationTabView',
    HasAllowTemplateInformationTab: 'HasTemplateInformationTab',
};

export const OnlineEntryPagefieldMapping = {
    AllowOnlineEntryPageView: 'OnlineEntryPageView',
    HasAllowOnlineEntryPage: 'HasOnlineEntryPage',
    AllowNewInvoiceButtonView: 'NewInvoiceButtonView',
    HasAllowNewInvoiceButton: 'HasNewInvoiceButton'

};
export const MonthClosurePagefieldMapping = {
    AllowMonthClosurePageView: 'MonthClosurePageView',
    HasAllowMonthClosurePage: 'HasMonthClosurePage',
    AllowSummaryTabView: 'SummaryTabView',
    HasAllowSummaryTab: 'HasSummaryTab',
    AllowAcknowledgeTabView: 'AcknowledgeTabView',
    HasAllowAcknowledgeTab: 'HasAcknowledgeTab',
    AllowTransactionTabView: 'TransactionTabView',
    HasAllowTransactionTab: 'HasTransactionTab',
    HasAllowAcceptButton: 'HasAcceptButton'
};

export const DataPagefieldMapping = {
    AllowInventoryPageView: 'InventoryPageView',
    HasAllowInventoryPage: 'HasInventoryPage',
    AllowGrossSalesPageView: 'GrossSalesPageView',
    HasAllowGrossSalesPage: 'HasGrossSalesPage'
};

export const HelpTopicPagefieldMapping = {
    AllowHelpTopicPageView: 'HelpTopicPageView',
    AllowNewTopicButtonView: 'NewTopicButtonView',
    HasAllowEditTopicButton: 'HasEditTopicButton',
    HasAllowCheckTopic: 'HasCheckTopic',
};

export const AddEditHelpTopicsPagefieldMapping = {
    AllowAddEditHelpTopicsPageView: 'AddEditHelpTopicsPageView',
    HasAllowAddEditHelpTopicsPage: 'HasAddEditHelpTopicsPage'
};

export const AdminMastersPagefieldMapping = {
    AllowAdminMastersPageView: 'AdminMastersPageView',
};

export const SubCategoryPagefieldMapping = {
    AllowSubCategoryPageView: 'SubCategoryPageView',
    HasAllowSubCategoryPage: 'HasSubCategoryPage',
};

export const HelpAndCommunicationPagefieldMapping = {
    AllowHelpAndDocumentsPageView: 'HelpAndDocumentsPageView',
    AllowHelpAndCommunicationViewPageView: 'HelpAndCommunicationViewPageView',
    AllowHelpAndCommunicationSearchPageView: 'HelpAndCommunicationSearchPageView',
    HasAllowViewMoreBlog: 'HasViewMoreBlog',
    HasAllowDownloadBlog: 'HasDownloadBlog',
};

